import { gql } from '@apollo/client';

import { AppBaseFields } from './apps.fragment';
export * from './appLinkProducts.mutation.generated';

export const APP_LINK_PRODUCTS = gql`
  mutation appLinkProducts($input: AppLinkProductsInput!) {
    appLinkProducts(input: $input) {
      errors
      success
      app {
        ...AppBaseFields
      }
    }
  }
  ${AppBaseFields}
`;
